import React, { useState } from "react";
import { signosConfigurables } from "../../Recetas electronicas/RecetaConfig";

const ConfigurableField = ({
  label,
  config,
  setConfig,
  fieldKey,
  labelKey,
  marginXKey,
  marginYKey,
  sizeHorizontalKey,
  sizeVerticalKey,
  sizeKey,
  colorKey,
  boldKey,
  fontKey,
  tipo, // Nuevo: "texto" o "linea"
}) => {
  const [showConfig, setShowConfig] = useState(false);

  // Función para manejar los cambios de configuración
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setConfig((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : type === "number" ? parseFloat(value) : value,
    }));
  };

  const moverPosicion = (key, cantidad) => {
    if (!key) return;

    setConfig((prev) => ({
      ...prev,
      [key]: Number(((Number(prev[key]) || 0) + cantidad).toFixed(2)),
    }));
  };

  return (
    <div className="configurable-field">
      <div className="header-config-nombre">
        <label className="campo-visible-label">
          <input
            type="checkbox"
            name={fieldKey}
            checked={config[fieldKey]}
            onChange={handleChange}
          />
          {label}
        </label>

        {config[fieldKey] && (
          <button
            type="button"
            onClick={() => setShowConfig(!showConfig)}
            className={`boton-config-icono ${showConfig ? "activo" : ""}`}
            title={showConfig ? "Ocultar configuración" : "Configurar campo"}
            aria-label={showConfig ? "Ocultar configuración" : `Configurar ${label}`}
          >
            ⚙️
          </button>
        )}
      </div>

      {/* Opciones de configuración avanzadas */}
      {showConfig && config[fieldKey] && (
        <div className="field-options">
          {/* Configuración compartida entre texto y línea */}
          {marginXKey && marginYKey && (
              <div className="control-posicion">
                <div className="control-posicion-titulo">Posición</div>

                <div className="control-posicion-contenido">

                  <div className="control-posicion-flechas">
                    <span />

                    <button
                      type="button"
                      className="boton-flecha-posicion"
                      onClick={() => moverPosicion(marginYKey, -0.1)}
                      title="Mover arriba"
                      aria-label="Mover arriba"
                    >
                      ↑
                    </button>

                    <span />

                    <button
                      type="button"
                      className="boton-flecha-posicion"
                      onClick={() => moverPosicion(marginXKey, -0.1)}
                      title="Mover izquierda"
                      aria-label="Mover izquierda"
                    >
                      ←
                    </button>

                    <span className="centro-posicion" />

                    <button
                      type="button"
                      className="boton-flecha-posicion"
                      onClick={() => moverPosicion(marginXKey, 0.1)}
                      title="Mover derecha"
                      aria-label="Mover derecha"
                    >
                      →
                    </button>

                    <span />

                    <button
                      type="button"
                      className="boton-flecha-posicion"
                      onClick={() => moverPosicion(marginYKey, 0.1)}
                      title="Mover abajo"
                      aria-label="Mover abajo"
                    >
                      ↓
                    </button>

                    <span />
                  </div>

                  <div className="ajuste-preciso-posicion">
                    <div className="ajuste-preciso-titulo">
                      Ajuste manual
                    </div>

                    <div className="ajuste-preciso-inputs">
                      <label>
                        <span>X</span>
                        <input
                          type="number"
                          name={marginXKey}
                          step="0.01"
                          value={config[marginXKey]}
                          onChange={handleChange}
                        />
                      </label>

                      <label>
                        <span>Y</span>
                        <input
                          type="number"
                          name={marginYKey}
                          step="0.01"
                          value={config[marginYKey]}
                          onChange={handleChange}
                        />
                      </label>
                    </div>
                  </div>

                </div>
              </div>
            )}

          {tipo === "texto" && (
            <>
              {/* Configuración específica para texto */}
              <label>
                Tamaño de Letra:
                <input
                  type="number"
                  name={sizeKey}
                  step="1"
                  value={config[sizeKey]}
                  onChange={handleChange}
                />
              </label>
              <label>
                Tipo de Letra:
                <select
                  name={fontKey}
                  value={config[fontKey]}
                  onChange={handleChange}
                >
                  <option value="Arial">Arial</option>
                  <option value="Helvetica">Helvetica</option>
                  <option value="Times New Roman">Times New Roman</option>
                  <option value="Georgia">Georgia</option>
                  <option value="Verdana">Verdana</option>
                  <option value="Trebuchet MS">Trebuchet MS</option>
                  <option value="Tahoma">Tahoma</option>
                  <option value="Courier New">Courier New</option>
                  <option value="Comic Sans MS">Comic Sans MS</option>
                  <option value="Lucida Console">Lucida Console</option>
                  <option value="Lucida Sans">Lucida Sans</option>
                  <option value="Cursive">Cursive</option>
                  <option value="Brush Script MT">Brush Script MT</option>
                  <option value="Lucida Handwriting">Lucida Handwriting</option>
                  <option value="Segoe Script">Segoe Script</option>
                  <option value="Monotype Corsiva">Monotype Corsiva</option>
                </select>
              </label>
              <label>
                Color del Texto:
                <input
                  type="color"
                  name={colorKey}
                  value={config[colorKey]}
                  onChange={handleChange}
                />
              </label>
              <label>
                Texto en Negritas:
                <input
                  type="checkbox"
                  name={boldKey}
                  checked={config[boldKey]}
                  onChange={handleChange}
                />
              </label>
                  {labelKey && (
              <label className="mostrar-etiqueta-control">
                {fieldKey === "mostrarSignos"
                  ? "Mostrar etiqueta general:"
                  : "Mostrar etiqueta:"}
                <input
                  type="checkbox"
                  name={labelKey}
                  checked={config[labelKey] ?? true}
                  onChange={handleChange}
                />
              </label>
            )}
            </>
          )}

          {fieldKey === "mostrarSignos" && (
            <div className="configuracion-signos">
              <label className="mostrar-etiqueta-control">
                Mostrar etiquetas internas:
                <input
                  type="checkbox"
                  name="mostrarEtiquetasInternasSignos"
                  checked={config.mostrarEtiquetasInternasSignos ?? true}
                  onChange={handleChange}
                />
              </label>

              <label>
                Distribución:
                <select
                  name="modoDistribucionSignos"
                  value={config.modoDistribucionSignos || "prosa"}
                  onChange={handleChange}
                >
                  <option value="prosa">En línea</option>
                  <option value="individual">Posición individual</option>
                </select>
              </label>

              <p>Signos a mostrar:</p>

              {signosConfigurables.map((signo) => (
                <div key={signo.visibleKey}>

                  <label>
                    <input
                      type="checkbox"
                      name={signo.visibleKey}
                      checked={config[signo.visibleKey] ?? true}
                      onChange={handleChange}
                    />
                    {signo.label}
                  </label>

                  {(config.modoDistribucionSignos || "prosa") === "individual" &&
                    config[signo.visibleKey] && (

                      <div className="control-posicion">

                        <div className="control-posicion-titulo">
                          Posición de {signo.label}
                        </div>

                        <div className="control-posicion-contenido">

                          <div className="control-posicion-flechas">

                            <span />

                            <button
                              type="button"
                              className="boton-flecha-posicion"
                              onClick={() => moverPosicion(signo.yKey, -0.1)}
                              title={`Mover ${signo.label} arriba`}
                            >
                              ↑
                            </button>

                            <span />

                            <button
                              type="button"
                              className="boton-flecha-posicion"
                              onClick={() => moverPosicion(signo.xKey, -0.1)}
                              title={`Mover ${signo.label} izquierda`}
                            >
                              ←
                            </button>

                            <span className="centro-posicion" />

                            <button
                              type="button"
                              className="boton-flecha-posicion"
                              onClick={() => moverPosicion(signo.xKey, 0.1)}
                              title={`Mover ${signo.label} derecha`}
                            >
                              →
                            </button>

                            <span />

                            <button
                              type="button"
                              className="boton-flecha-posicion"
                              onClick={() => moverPosicion(signo.yKey, 0.1)}
                              title={`Mover ${signo.label} abajo`}
                            >
                              ↓
                            </button>

                            <span />

                          </div>

                          <div className="ajuste-preciso-posicion">

                            <div className="ajuste-preciso-titulo">
                              Ajuste manual
                            </div>

                            <div className="ajuste-preciso-inputs">

                              <label>
                                <span>X</span>
                                <input
                                  type="number"
                                  name={signo.xKey}
                                  step="0.01"
                                  value={config[signo.xKey] ?? 0}
                                  onChange={handleChange}
                                />
                              </label>

                              <label>
                                <span>Y</span>
                                <input
                                  type="number"
                                  name={signo.yKey}
                                  step="0.01"
                                  value={config[signo.yKey] ?? 0}
                                  onChange={handleChange}
                                />
                              </label>

                            </div>

                          </div>

                        </div>

                      </div>
                    )}

                </div>
              ))}

            </div>
          )}


        {tipo === "linea" && (
            <>
              {/* Configuración específica para línea */}
              <label>
                Tamaño Vertical:
                <input
                  type="number"
                  name={sizeVerticalKey}
                  step="1"
                  value={config[sizeVerticalKey]}
                  onChange={handleChange}
                />
              </label>
              
              <label>
                Color de la Línea:
                <input
                  type="color"
                  name={colorKey}
                  value={config[colorKey]}
                  onChange={handleChange}
                />
              </label>
              <label>
                Tamaño Horizontal (ancho):
                <input
                  type="number"
                  name={sizeHorizontalKey}
                  step="1"
                  value={config[sizeHorizontalKey]}
                  onChange={handleChange}
                />
              </label>
            </>
          )}
          {(tipo === "imagen" || tipo === "marcaAgua") && (
            <>
              {/* Configuración específica para imagen y marca de agua */}
              <label>
                Ancho:
                <input
                  type="number"
                  name={sizeHorizontalKey}
                  step="0.1"
                  value={config[sizeHorizontalKey]}
                  onChange={handleChange}
                />
              </label>
              <label>
                Alto:
                <input
                  type="number"
                  name={sizeVerticalKey}
                  step="0.1"
                  value={config[sizeVerticalKey]}
                  onChange={handleChange}
                />
              </label>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default ConfigurableField;
